//Firebase Web SDK 初始化（Web 端的 Firebase Auth 用）
//
//  env 變數（CRA 規定要 REACT_APP_ 前綴才會被打包進 client）：
//    REACT_APP_FIREBASE_API_KEY
//    REACT_APP_FIREBASE_AUTH_DOMAIN     例：yuanchen.firebaseapp.com
//    REACT_APP_FIREBASE_PROJECT_ID      例：yuanchen
//    REACT_APP_FIREBASE_APP_ID
//    REACT_APP_FIREBASE_STORAGE_BUCKET  選填（client 暫時不直接用 storage）
//    REACT_APP_FIREBASE_MESSAGING_SENDER_ID  選填
//
//  以上值請到 Firebase Console → 專案設定 → 一般 → 「您的應用程式」→ Web 應用程式
//  那一段把 firebaseConfig 物件的值貼進來。這些值對外是公開的（client 一定看得到），
//  真正的安全是靠 Firebase Auth 規則 + 後端 verifyIdToken。

import { initializeApp, getApps } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
};

//確保整個 app 只 init 一次（Hot reload 時 getApps() 已有實例就直接拿）
const firebaseApp = getApps().length
  ? getApps()[0]
  : initializeApp(firebaseConfig);

const auth = getAuth(firebaseApp);

//Google provider：固定要求 email scope（其實 default 就有，明寫保險）
const googleProvider = new GoogleAuthProvider();
googleProvider.addScope("email");
googleProvider.addScope("profile");

//觸發 Google 登入 popup，回傳 Firebase ID Token（要傳給後端 /firebase-login 驗證）
//  失敗 / 使用者關掉 popup 會 throw（呼叫端要 catch）
export const signInWithGoogle = async () => {
  const result = await signInWithPopup(auth, googleProvider);
  const idToken = await result.user.getIdToken();
  return { idToken, user: result.user };
};

export { auth, firebaseApp };
